import styled from 'styled-components'
import { device } from '../../../utils/helpers'

export const CardHeader = styled.div`
  height: 60px;
  display: flex;
  flex-direction: column;
  background: #999999;
  justify-content: center;
  width: 100%;
  background-color: ${props => props.selected ? props.theme.color.hoverPrimary : 'none'};

  @media ${device.mobileM} {
    height: 70px;
  }

  @media ${device.tablet} {
    ${''/* height: 80px; */}
    height: 7.161458333333334vw;
  }

  @media ${device.laptop} {
    ${''/* height: 80px; */}
    height: 7.083333333333334vw;
  }

  ${'' /* @media ${device.laptopM} {
    height: 90px;
  }

  @media ${device.laptopM} {
    height: 95px;
  }

  @media ${device.laptopL} {
    height: 110px;
  }

  @media (min-width: 1770px) {
    height: 136px;
  } */}
`

export const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  justify-content: space-between;
  text-align: center;
  cursor: pointer;
  border: 5px solid ${props => props.selected ? props.theme.color.hoverPrimary : 'transparent'};
  outline: none;
  margin: 10px 0;

  @media ${device.mobileM} {
    width: 240px;
  }

  @media ${device.tablet} {
    ${''/* width: 200px; */}
    width: 21.223958333333336vw;
  }

  @media ${device.laptop} {
    ${''/* width: 200px; */}
    width: 21.354166666666668vw;
  }

  ${'' /* @media ${device.laptop} {
    width: 200px;
  }

  @media ${device.laptopM} {
    width: 235px;
  }

  @media ${device.laptopL} {
    width: 305px;
  }

  @media (min-width: 1770px) {
    width: 407px;
  } */}

  &:hover {
    border: 5px solid ${props => props.theme.color.hoverPrimary};
  }

  &:hover ${CardHeader} {
    background-color: ${props => props.theme.color.hoverPrimary};
  }
`

export const InnerWrapper = styled.div`
  padding: 0 20px;
  background-color: #F3F3F3;
  width: -moz-available;

  @media ${device.tablet} {
    ${''/* padding: 0 25px; */}
    padding: 0 1.3020833333333335vw;
  }

  ${'' /* @media ${device.laptopM} {
    padding: 0 20px;
  }

  @media ${device.laptopL} {
    padding: 0 25px;
  } */}

  ${'' /* @media (min-width: 1770px) {
    padding: 0 25px;
  } */}
`

export const CardFooter = styled.div`
  background-color: #F3F3F3;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 50px;
  padding-top: 11px;
  padding-bottom: 14px;

  @media ${device.mobileM} {
    height: 65px;
    padding-top: 20px;
    padding-bottom: 16px;
  }

  @media ${device.tablet} {
    ${''/* height: 65px; */}
    height: 5.208333333333334vw;
    ${'' /* padding-top: 38px;
    padding-bottom: 28px; */}
    padding-top: 1.9791666666666667vw;
    padding-bottom: 1.4583333333333335vw;
  }

  ${'' /* @media ${device.laptop} {
    height: 65px;
    padding-top: 20px;
    padding-bottom: 16px;
  }

  @media ${device.laptopM} {
    height: 70px;
    padding-top: 22px;
    padding-bottom: 20px;
  }

  @media ${device.laptopL} {
    height: 80px;
    padding-top: 28px;
    padding-bottom: 20px;
  }

  @media (min-width: 1770px) {
    height: 100px;
    padding-top: 38px;
    padding-bottom: 28px;
  } */}
`

export const Image = styled.img`
  width: 100%;
  height: 86px;
  padding-top: 9px;

  @media ${device.mobileM} {
    height: 140px;
    padding-top: 12px;
  }

  @media ${device.tablet} {
    ${''/* height: 120px; */}
    height: 11.71875vw;
    ${''/* padding-top: 12px; */}
    padding-top: 1.3020833333333335vw;
  }

  ${'' /* @media ${device.laptop} {
    height: 120px;
    padding-top: 12px;
  }

  @media ${device.laptopM} {
    height: 145px;
    padding-top: 15px;
  }

  @media ${device.laptopL} {
    height: 165px;
    padding-top: 20px;
  }

  @media (min-width: 1770px) {
    height: 225px;
    padding-top: 25px;
  } */}
`



// WEBPACK FOOTER //
// ./src/components/Calculator/Card/Common.js